import {createStyles, Theme} from "@material-ui/core";
import {styleColors, typography} from "src/main.style";

export const CheckboxStyle = (theme: Theme) => createStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1),
    },
    label: {
        ...typography.label,
        color: theme.palette.common.black,
        display: 'flex',
        flexDirection: 'row',
        gap: theme.spacing(1.5),
    },
    validLabel: {
        color: theme.palette.common.black,
    },
    invalidLabel: {
        color: theme.palette.error.main,
    },
    checkbox: {
        appearance: 'none',
        outline: 'none',
        width: '16px',
        minWidth: '16px',
        height: '16px',
        minHeight: '16px',
        borderRadius: '0.1875rem',
        border: '1px solid',
        borderColor: theme.palette.common.black,
        margin: 0,
        background: theme.palette.common.white,
        position: 'relative',
        boxSizing: 'content-box',

        '&:after': {
            position: 'absolute',
            content: '" "',
            top: '1px',
            left: '6px',
            transform: 'rotate(45deg)',
            width: "3px",
            height: "8px",
            border: `solid ${styleColors.white}`,
            borderWidth: '0 2px 2px 0',
            display: 'none',
        },

        '&:checked': {
            background: theme.palette.primary.main,
            borderColor: theme.palette.primary.main,
            color: theme.palette.common.white,

            '&:after': {
                display: 'block',
            }
        },
    },
    focusedCheckbox: {
        outline: '1px solid',
        outlineColor: theme.palette.common.black,
        borderColor: theme.palette.common.black,
        borderRadius: '0.1875rem',
    },
    invalidCheckbox: {
        outline: '1px solid',
        outlineColor: theme.palette.error.main,
        borderColor: theme.palette.error.main,
        borderRadius: '0.1875rem',
    },
    errorMessage:{
        ...typography.feedback,
        color: theme.palette.error.main,
    }
});



// WEBPACK FOOTER //
// ./src/components/common/checkbox/checkbox.style.ts